// src/components/steps/ContractLengthStep.js
import React from 'react';
import { CONTRACT_DISCOUNTS } from '../../utils/quoteUtils.js';

function ContractLengthStep({ state, setState, setCurrentStep }) {
  return (
    <div className="space-y-6">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contract Length</h2>
        <p className="text-gray-600 mb-6">Select your contract duration for better pricing</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {Object.entries(CONTRACT_DISCOUNTS).map(([months, discount]) => {
          const isSelected = state.contractLength === parseInt(months);
          return (
            <button
              key={months}
              onClick={() => {
                setState(prev => ({ ...prev, contractLength: parseInt(months) }));
                setCurrentStep(9);
              }}
              className={`
                p-6 rounded-lg border transition-all duration-200 text-left
                ${isSelected
                  ? 'border-blue-500 bg-blue-50 shadow-md'
                  : 'border-gray-200 hover:border-blue-300 hover:bg-blue-50'
                }
              `}
            >
              <h3 className="font-medium text-lg text-gray-900">{months} Months</h3>
              <div className="mt-4 text-blue-600 font-medium">
                {(discount * 100).toFixed(0)}% discount
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ContractLengthStep;
